// extracted by mini-css-extract-plugin
export default {"title":"Title_title__6O17G","text":"Title_text__i6Y+1","icon":"Title_icon__CxKCu"};